import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const metricsClient = axios.create({
  baseURL: process.env.VUE_APP_METRICS_URL,
  withCredentials: true,
});

metricsClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(metricsClient);

export default metricsClient;
